__turbopack_context__.v({
  "group": "FooterLinks-module__EIL70q__group",
  "groups": "FooterLinks-module__EIL70q__groups",
  "menuList": "FooterLinks-module__EIL70q__menuList",
  "menuListItem": "FooterLinks-module__EIL70q__menuListItem",
});
